<template>
  <div class="chat-toggle" v-if="dados.status === 1">
    <a href="javascript:" class="p-1" @click="openActions">
      <i class="fa fa-ellipsis-v text-secondary"></i>
    </a>
    <div :id="'chat' + id" class="chat-actions" :class="{show}" tabindex="0" @blur="show = false" @click="show = false">
      <ul class="ul">
        <li class="li d-none">
          <a href="javascript:" class="text-decoration-none text-dark">Dados do pedido</a>
        </li>
        <li class="li">
          <a href="javascript:" class="text-decoration-none text-dark" @click="$emit('finalizar', dados.id_chat)">Finalizar Chat</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatToggle",
  props: ['dados'],
  data() {
    return {
      show: false,
      id: this.$helpers.ID()
    }
  },

  methods: {
    openActions() {
      this.show = !this.show;
      this.$nextTick(() => {
        if (this.show) {
          this.$helpers.focusElement('chat' + this.id);
        }
      })
    },

    clearChat() {
      this.$swal({
        text: "Deseja realmente limpar todo histórico desta conversa?",
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.$emit('chatEvent', 2);
        }
      }));
    },

    transferChat() {
      this.$emit('chatEvent', 4);
    }
  },
}
</script>

<style scoped>
</style>